import React from 'react';
import clsx from 'clsx';

const variants = {
  success: 'bg-wa-accent-green/12 text-wa-accent-green',
  warning: 'bg-wa-accent-orange/12 text-wa-accent-orange',
  danger: 'bg-wa-accent-red/12 text-wa-accent-red',
  info: 'bg-wa-500/12 text-wa-500',
  neutral: 'bg-gray-100 text-gray-600',
  purple: 'bg-wa-accent-purple/12 text-wa-accent-purple',
  orange: 'bg-wa-accent-orange/12 text-wa-accent-orange',
};

export default function Badge({
  text,
  variant = 'neutral',
  size = 'sm',
}: {
  text: string;
  variant?: keyof typeof variants;
  size?: 'sm' | 'md';
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full font-semibold',
        variants[variant],
        size === 'sm' ? 'px-2.5 py-0.5 text-[11px]' : 'px-3 py-1 text-xs',
      )}
    >
      {text}
    </span>
  );
}
